<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.cuttingTool.form.name')" prop="name" >
        <a-input v-model="form.name" :placeholder="$t('views.cuttingTool.form.namePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.cuttingTool.form.bagWidth')" prop="bagWidth" >
        <a-input v-model="form.bagWidth" :placeholder="$t('views.cuttingTool.form.bagWidthPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.cuttingTool.form.toolingFee')" prop="toolingFee" >
        <a-input v-model="form.toolingFee" :placeholder="$t('views.cuttingTool.form.toolingFeePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.cuttingTool.form.comparisonSymbols')" prop="comparisonSymbols" >
        <a-select v-model="form.comparisonSymbols" :placeholder="$t('views.cuttingTool.form.comparisonSymbolsPlaceholder')" allow-clear>
          <a-select-option value=">">&gt;</a-select-option>
          <a-select-option value="<">&lt;</a-select-option>
          <a-select-option value=">=">&gt;=</a-select-option>
          <a-select-option value="<=">&lt;=</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.cuttingTool.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.cuttingTool.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCuttingTool, addCuttingTool, updateCuttingTool } from '@/api/user/cuttingTool'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        name: null,
        bagWidth: null,
        toolingFee: null,
        comparisonSymbols: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false
    }
  },
  computed: {
    rules () {
      return {}
    }
  },
  watch: {
    '$i18n.locale' () {
      if (!this.open) return
      this.formTitle = this.formType === 2 ? this.$t('views.cuttingTool.title.edit') : this.$t('views.cuttingTool.title.add')
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        bagWidth: null,
        toolingFee: null,
        comparisonSymbols: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('views.cuttingTool.title.add')
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCuttingTool({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('views.cuttingTool.title.edit')
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCuttingTool(this.form).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.cuttingTool.msg.updateOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.cuttingTool.msg.updateFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCuttingTool(this.form).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.cuttingTool.msg.addOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.cuttingTool.msg.addFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
